@if (showMobileHeader$ | async) {
  <div class="gallery-destination">
    <div class="background" [class.animation]="headerAnimation"></div>
    @defer (when (isLoadingHome$ | async) === false) {
      <app-gallery-destination
        [isMobile]="isMobile$ | async"
        [images]="(homeData$ | async)?.banners"
        [height]="heightGallery"
        [source]="source"
        (trackEvent)="trackEvent($event)">
      </app-gallery-destination>
    }
  </div>
}

@if ((isLoadingHome$ | async) === false) {
  <div class="homeCont" #homeContainer>
    @if (isMobile$ | async) {
      <div class="homeCont__searchText" *ngIf="routeSearch$ | async as route" [class.hidden]="headerAnimation" [routerLink]="route">
        <app-ds-input-search
          [isReadonly]="true"
          [placeholder]="'TITLE_SEARCH_HOME' | transloco">
        </app-ds-input-search>
      </div>
  
      <ng-container *ngFor="let group of countryModulesCollection$ | async; trackBy: itemTrackBy">
        @if (group.key) {
          <div class="homeCont__chip-group-title">
            <app-ds-typography
              [fontFamily]="fontFamily.Regular"
              [size]="fontSize.Smaller"
              [color]="fontColor.Secondary"
              [text]="group.key | transloco | uppercase">
            </app-ds-typography>
          </div>
        }
        <div class="homeCont__chips">
          <app-chip-cont [isSlider]="false">
            <ng-container *ngFor="let module of group?.value;">
              <div class="homeCont__chips__chip-action">
                <app-ds-chip-action
                  [label]="module.title | transloco"
                  [icon]="module.icon"
                  [branding]="module.chipBranding"
                  (clickEvent)="chipActionEvent(module)">
                </app-ds-chip-action>
              </div>
            </ng-container>
          </app-chip-cont>
        </div>
      </ng-container>
    }
  
    @if ((isMobile$ | async) === false) {
      <div class="gallery-destination">
        <div class="background" [class.animation]="headerAnimation"></div>
          <app-gallery-destination
            [isMobile]="isMobile$ | async"
            [images]="(homeData$ | async)?.banners"
            [height]="heightGallery"
            [source]="source">
          </app-gallery-destination>
        </div>
      <div class="wrapper-search">
        <app-home-search-desktop></app-home-search-desktop>
      </div>
    }
  
    <div class="section-list">
      <app-home-section-list
        [isMobile]="isMobile$ | async"
        [source]="source"
        [homeSections]="(homeData$ | async)?.sections"
        [pageCode]="(homeData$ | async)?.code"
        (trackStoreSelected)="trackEvent($event)">
        <div class="widgets" homeWidgets="homeWidgets">
          <div class="abandoned-reservation">
            <app-abandoned-reservation></app-abandoned-reservation>
          </div>
          <app-recent-searches [index]="0"></app-recent-searches>
        </div>
      </app-home-section-list>
      <div [innerHTML]="footerDynamic|safeHtml"></div>
    </div>
  
    @defer (when (isMobile$ | async)) {
      @if (isMobile$ | async) {
        <app-footer [isMobile]="true"></app-footer>
      }
    }
  </div>
} @else {
  <app-home-placeholder></app-home-placeholder>
}
